import {gsap} from "gsap";

document.addEventListener('DOMContentLoaded', function () {
    const gallery = document.getElementById('image-gallery');
    const imageSets = document.querySelectorAll('.image-set');

    if (gallery) {
        gsap.to(gallery, {
            xPercent: -100,
            duration: 20,
            repeat: -1,
            ease: 'linear',
            paused: false
        });

        const images = document.querySelectorAll('.image-item');
        gsap.from(images, {
            opacity: 0,
            scale: 0.5,
            duration: 1,
            stagger: 0.2,
            ease: 'power4.out',
        });
    }
});